import { call, put, select, takeLatest } from "redux-saga/effects";
import { CognitoClient } from "../../lib/cognitoClient";
import { answerMfaChoiceChallenge, handleAuthResponse, handleError, saveCognitoUserObject } from "../actions/loginactioncreators";
import getUsername from "../helpers/getUsername";
import { normalizePayload } from "../helpers/normalizePayload";
import getClientId from "../helpers/getClientId";
import actiontypes from "../actions/actiontypes";
import getUserPoolId from "../helpers/getUserPoolId";
import getloginClientId from "../helpers/getLoginClientId";
import getLocale from "../helpers/getLocale"

export function* loginAsync(action) {
    const { password, resendOtp, deliveryMedium, accountNumber } = action.payload;

    try {
        const AmazonCognitoAdvancedSecurityData = window["AmazonCognitoAdvancedSecurityData"];
        const username = yield select(getUsername);
        const clientId = yield select(getloginClientId);
        const actualClientId = yield select(getClientId);
        const userPoolId = yield select(getUserPoolId);
        const locale = yield select(getLocale);

        const clientMetadata = { actualClientId, locale, accountNumber, username };
        const cognitoLogin = { username, password };

        const encodedData = AmazonCognitoAdvancedSecurityData.getData(username, userPoolId, clientId);
        let payload = normalizePayload(action.payload);
        payload.userContextData = encodedData;

        CognitoClient.initialize(userPoolId, clientId);
        // We need to invalidate the current user before allowing another user to log in
        const currentUser = yield call(CognitoClient.getCurrentUser);
        if (currentUser) {
            yield call(CognitoClient.signOutCurrentUser);
        }
        const authResponse = yield call(CognitoClient.authenticate, cognitoLogin, clientMetadata);

        // We need this user context stored for MFA, among other reasons
        yield put(saveCognitoUserObject(cognitoLogin));
        if (resendOtp) {
            yield put(answerMfaChoiceChallenge({ deliveryMedium, resendOtp }));
        } else {
            yield put(handleAuthResponse(authResponse));
        }
    } catch (error) {
        yield put(handleError(error));
    }
}

export function* watchLoginAsync() {
    yield takeLatest(actiontypes.USER_LOGIN, loginAsync);
}